import { render, staticRenderFns } from "./DDDInformationForm.vue?vue&type=template&id=3efe0f0b&"
import script from "./DDDInformationForm.vue?vue&type=script&lang=js&"
export * from "./DDDInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports